<template>
  <TVFinderApp/>
</template>

<script>
import TVFinderApp from './components/TVFinderApp.vue';

export default {
  name: 'App',
  components: {
    TVFinderApp
  }
}
</script>

